import { render, staticRenderFns } from "./MemberList.vue?vue&type=template&id=c2115336&scoped=true"
import script from "./MemberList.vue?vue&type=script&lang=js"
export * from "./MemberList.vue?vue&type=script&lang=js"
import style0 from "./MemberList.vue?vue&type=style&index=0&id=c2115336&prod&lang=scss&scoped=true"
import style1 from "./MemberList.vue?vue&type=style&index=1&id=c2115336&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2115336",
  null
  
)

export default component.exports